
export enum UnitBusinessVertical {
    None = 0,
    AgricultureForestryFishingOrHunting = 1,
    ArtsEntertainmentAndRecreation = 2,
    BusinessSupportOrBuildingServices = 3,
    Cannabis = 4,
    Construction = 5,
    DirectMarketingOrTelemarketing = 6,
    EducationalServices = 7,
    FinancialServicesCryptocurrency = 8,
    FinancialServicesDebitCollectionOrConsolidation = 9,
    HealthCareAndSocialAssistance = 10,
    FinancialServicesMoneyServicesBusinessOrCurrencyExchange = 11,
    FinancialServicesOther = 12,
    FinancialServicesPaydayLending = 13,
    GamingOrGambling = 14,
    HospitalityAccommodationOrFoodServices = 15,
    LegalAccountingConsultingOrComputerProgramming = 16,
    Manufacturing = 17,
    Mining = 18,
    Nutraceuticals = 19,
    PersonalCareServices = 20,
    PublicAdministration = 21,
    RealEstate = 22,
    ReligiousCivicAndSocialOrganizations = 23,
    RepairAndMaintenance = 24,
    RetailTrade = 25,
    TechnologyMediaOrTelecom = 26,
    TransportationOrWarehousing = 27,
    Utilities = 28,
    WholesaleTrade = 29,
    AdultEntertainmentDatingOrEscortServices = 30
}

export namespace UnitBusinessVertical {
    export function toString(businessVertical: UnitBusinessVertical) {
        switch (businessVertical) {
            case UnitBusinessVertical.AgricultureForestryFishingOrHunting:
                return "Agriculture, Forestry, Fishing or Hunting";
            case UnitBusinessVertical.ArtsEntertainmentAndRecreation:
                return "Arts, Entertainment and Recreation";
            case UnitBusinessVertical.BusinessSupportOrBuildingServices:
                return "Business Support or Building Services";
            case UnitBusinessVertical.Cannabis:
                return "Cannabis";
            case UnitBusinessVertical.Construction:
                return "Construction";
            case UnitBusinessVertical.DirectMarketingOrTelemarketing:
                return "Direct Marketing/Telemarketing";
            case UnitBusinessVertical.EducationalServices:
                return "Educational Services";
            case UnitBusinessVertical.FinancialServicesCryptocurrency:
                return "Financial Services - Cryptocurrency";
            case UnitBusinessVertical.FinancialServicesDebitCollectionOrConsolidation:
                return "Financial Services - Debit Collection or Consolidation";
            case UnitBusinessVertical.HealthCareAndSocialAssistance:
                return "Health Care and Social Assistance";
            case UnitBusinessVertical.FinancialServicesMoneyServicesBusinessOrCurrencyExchange:
                return "Financial Services - Money Services Business or Currency Exchange";
            case UnitBusinessVertical.FinancialServicesOther:
                return "Financial Services - Other";
            case UnitBusinessVertical.FinancialServicesPaydayLending:
                return "Financial Services - Payday Lending";
            case UnitBusinessVertical.GamingOrGambling:
                return "Gaming/Gambling";
            case UnitBusinessVertical.HospitalityAccommodationOrFoodServices:
                return "Hospitality, Accommodation or Food Services";
            case UnitBusinessVertical.LegalAccountingConsultingOrComputerProgramming:
                return "Legal, Accounting, Consulting or Computer Programming";
            case UnitBusinessVertical.Manufacturing:
                return "Manufacturing";
            case UnitBusinessVertical.Mining:
                return "Mining";
            case UnitBusinessVertical.Nutraceuticals:
                return "Nutraceuticals";
            case UnitBusinessVertical.PersonalCareServices:
                return "Personal Care Services";
            case UnitBusinessVertical.PublicAdministration:
                return "Public Administration";
            case UnitBusinessVertical.RealEstate:
                return "Real Estate";
            case UnitBusinessVertical.ReligiousCivicAndSocialOrganizations:
                return "Religious, Civic and Social Organizations";
            case UnitBusinessVertical.RepairAndMaintenance:
                return "Repair and Maintenance";
            case UnitBusinessVertical.RetailTrade:
                return "Retail Trade";
            case UnitBusinessVertical.TechnologyMediaOrTelecom:
                return "Technology, Media or Telecom";
            case UnitBusinessVertical.TransportationOrWarehousing:
                return "Transportation or Warehousing";
            case UnitBusinessVertical.Utilities:
                return "Utilities";
            case UnitBusinessVertical.WholesaleTrade:
                return "Wholesale Trade";
            case UnitBusinessVertical.AdultEntertainmentDatingOrEscortServices:
                return "Adult Entertainment, Dating or Escort Services";
        }
    }

    export function listAll() {
        return [
            UnitBusinessVertical.RealEstate,
            UnitBusinessVertical.Construction,
            UnitBusinessVertical.RetailTrade,
            UnitBusinessVertical.RepairAndMaintenance,
            UnitBusinessVertical.TransportationOrWarehousing,
            UnitBusinessVertical.FinancialServicesMoneyServicesBusinessOrCurrencyExchange,
            UnitBusinessVertical.FinancialServicesCryptocurrency,
            UnitBusinessVertical.FinancialServicesPaydayLending,
            UnitBusinessVertical.FinancialServicesDebitCollectionOrConsolidation,
            UnitBusinessVertical.FinancialServicesOther,
            UnitBusinessVertical.Manufacturing,
            UnitBusinessVertical.WholesaleTrade,
            UnitBusinessVertical.LegalAccountingConsultingOrComputerProgramming,
            UnitBusinessVertical.BusinessSupportOrBuildingServices,
            UnitBusinessVertical.PublicAdministration,
            UnitBusinessVertical.DirectMarketingOrTelemarketing,
            UnitBusinessVertical.EducationalServices,
            UnitBusinessVertical.HealthCareAndSocialAssistance,
            UnitBusinessVertical.Utilities,
            UnitBusinessVertical.HospitalityAccommodationOrFoodServices,
            UnitBusinessVertical.ArtsEntertainmentAndRecreation,
            UnitBusinessVertical.AdultEntertainmentDatingOrEscortServices,
            UnitBusinessVertical.GamingOrGambling,
            UnitBusinessVertical.PersonalCareServices,
            UnitBusinessVertical.ReligiousCivicAndSocialOrganizations,
            UnitBusinessVertical.TechnologyMediaOrTelecom,
            UnitBusinessVertical.Cannabis,
            UnitBusinessVertical.Nutraceuticals,
            UnitBusinessVertical.AgricultureForestryFishingOrHunting,
            UnitBusinessVertical.Mining
        ]
    }

    export function parse(str: string): UnitBusinessVertical {
        return UnitBusinessVertical[str];
    }
}